import { render, staticRenderFns } from "./RecolhimentosPage.vue?vue&type=template&id=4d4b659e&"
import script from "./RecolhimentosPage.vue?vue&type=script&lang=js&"
export * from "./RecolhimentosPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports